import { Flex } from "antd";
import { FC } from "react";

import BaseButton from "@/shared/ui/BaseButton";
import { BaseModal } from "@/shared/ui/BaseModal";
import { SecondaryText } from "@/shared/ui/Typography";

import { StyledDangerIcon } from "./Styled";

export interface IgnoreRemainingConfirmProps {
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

export const IgnoreRemainingConfirm: FC<IgnoreRemainingConfirmProps> = ({
    open,
    onConfirm,
    onClose,
}) => {
    return (
        <BaseModal
            open={open}
            footer={[]}
            actions={null}
            onClose={() => onClose()}
            title={"Ви впевнені?"}
            icon={<StyledDangerIcon />}
        >
            <Flex vertical gap={16}>
                <SecondaryText fontSize={16}>
                    Відсутні на складі товари не будуть доставлені в магазин.
                    Підтверджуючи ігнорування залишків, ви приймаєте ризик
                    невідповідності замовлення фактичній поставці. Ви впевнені?
                </SecondaryText>

                <Flex vertical gap={8}>
                    <BaseButton
                        bgColor="success"
                        type="primary"
                        onClick={() => onConfirm()}
                    >
                        Підтвердити
                    </BaseButton>

                    <BaseButton type="default" onClick={() => onClose()}>
                        Повернутися назад
                    </BaseButton>
                </Flex>
            </Flex>
        </BaseModal>
    );
};
